// extracted by mini-css-extract-plugin
export default {"tabsRoot":"mwnzbNxyBEk3cTH1lxwt","tabsList":"Ed9Z_VnYfAP2VH3QW2RE"};